import Proptypes from 'prop-types';
import React from 'react';

const SellDashboard = ({ height = '100%', width = '100%' }) => (
  <svg
    height={height}
    version="1.1"
    viewBox="0 0 166 122"
    width={width}
    xmlns="https://www.w3.org/2000/svg"
  >
    <title>Group 3</title>
    <desc>Created with Sketch.</desc>
    <defs />
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g
        id="Step-4-/-one-conf-updated-icons-add-bank"
        transform="translate(-1037.000000, -518.000000)"
      >
        <g id="Group-3" transform="translate(1038.000000, 518.000000)">
          <g id="Group-15-Copy">
            <path
              d="M146.109091,114.998155 C146.109091,118.867984 120.744024,122 89.4556938,122 C58.1650674,122 32.8,118.867984 32.8,114.998155 C32.8,111.132016 58.1650674,108 89.4556938,108 C120.744024,108 146.109091,111.132016 146.109091,114.998155"
              fill="#E6F9FB"
            />
            <g id="Group-12">
              <path
                className="college-branded-icon-background"
                d="M83.0852366,0 C41.5907606,0 7.95151515,34.0137964 7.95151515,75.9702862 C7.95151515,87.1493138 10.3595509,97.7528665 14.6459297,107.308029 L151.524544,107.308029 C155.810922,97.7528665 158.218958,87.1493138 158.218958,75.9702862 C158.218958,34.0137964 124.579713,0 83.0852366,0 Z"
                fill="#E6F9FB"
              />
              <path
                d="M9.11111111,106.944444 L155.621868,106.944444"
                stroke="#054C70"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M0,106.944444 L4.69585759,106.944444"
                stroke="#054C70"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M158.938272,106.944444 L163.634129,106.944444"
                stroke="#054C70"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </g>
          <g id="Group-8" transform="translate(38.763636, 34.000000)">
            <path
              d="M5.33345305,77.553986 C2.40017609,77.553986 0.000222217951,75.1262231 0.000222217951,72.1589574 L0.000222217951,18.6132983 L88.9318463,18.6132983 L88.9318463,72.1589574 C88.9318463,75.1262231 86.5318924,77.553986 83.5986155,77.553986 L5.33345305,77.553986 Z"
              fill="#FFFFFF"
              stroke="#054C70"
            />
            <path
              d="M88.9316241,18.6128487 L0,18.6128487 L0,5.39502862 C0,2.42776288 2.39995387,0 5.33323083,0 L83.5983932,0 C86.5316702,0 88.9316241,2.42776288 88.9316241,5.39502862 L88.9316241,18.6128487 Z"
              fill="#FFFFFF"
            />
            <path
              d="M12.0968518,9.10214146 C12.0968518,10.815063 10.7235449,12.2042829 9.03024409,12.2042829 C7.3369433,12.2042829 5.96363636,10.815063 5.96363636,9.10214146 C5.96363636,7.38921987 7.3369433,6 9.03024409,6 C10.7235449,6 12.0968518,7.38921987 12.0968518,9.10214146 Z"
              stroke="#054C70"
              className="college-branded-icon-btn-1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.5328618,9.30619958 C24.5328618,11.0191212 23.1595549,12.408341 21.4662541,12.408341 C19.7729533,12.408341 18.3996464,11.0191212 18.3996464,9.30619958 C18.3996464,7.59327799 19.7729533,6.20405812 21.4662541,6.20405812 C23.1595549,6.20405812 24.5328618,7.59327799 24.5328618,9.30619958 Z"
              stroke="#054C70"
              className="college-branded-icon-btn-2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M36.7992927,9.30619958 C36.7992927,11.0191212 35.4259858,12.408341 33.732685,12.408341 C32.0393842,12.408341 30.6660773,11.0191212 30.6660773,9.30619958 C30.6660773,7.59327799 32.0393842,6.20405812 33.732685,6.20405812 C35.4259858,6.20405812 36.7992927,7.59327799 36.7992927,9.30619958 Z"
              stroke="#054C70"
              className="college-branded-icon-btn-3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M57.5768934,68.2473368 L49.7548215,68.2473368 C48.5281784,68.2473368 47.532642,67.2402648 47.532642,65.9994082 L47.532642,58.0866996 C47.532642,56.845843 48.5281784,55.838771 49.7548215,55.838771 L57.5768934,55.838771 C58.8035365,55.838771 59.7990729,56.845843 59.7990729,58.0866996 L59.7990729,65.9994082 C59.7990729,67.2402648 58.8035365,68.2473368 57.5768934,68.2473368 Z"
              fill="#FFFFFF"
              stroke="#054C70"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M77.5093992,68.2473368 L69.6873273,68.2473368 C68.4606842,68.2473368 67.4651478,67.2402648 67.4651478,65.9994082 L67.4651478,58.0866996 C67.4651478,56.845843 68.4606842,55.838771 69.6873273,55.838771 L77.5093992,55.838771 C78.7382644,55.838771 79.7315787,56.845843 79.7315787,58.0866996 L79.7315787,65.9994082 C79.7315787,67.2402648 78.7382644,68.2473368 77.5093992,68.2473368 Z"
              fill="#FFFFFF"
              stroke="#054C70"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M88.9316241,18.6128487 L0,18.6128487 L0,5.39502862 C0,2.42776288 2.39995387,0 5.33323083,0 L83.5983932,0 C86.5316702,0 88.9316241,2.42776288 88.9316241,5.39502862 L88.9316241,18.6128487 Z"
              stroke="#054C70"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g
            id="Group-2"
            stroke="#054C70"
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(88.460606, 57.000000)"
          >
            <path d="M0,1 L16.8969697,1" id="Stroke-19" strokeWidth="2" />
            <path d="M0,7 L29.8181818,7" id="Stroke-23" />
            <path d="M0,12 L24.3515152,12" id="Stroke-23-Copy" />
          </g>
          <g fillRule="nonzero" transform="translate(45.721212, 56.000000)">
            <path
              d="M14.7648987,3.21621622 L14.8475559,18.2837446 L29.6831095,18.3007667 C29.6018923,26.4775664 22.9883827,33.0808842 14.8419328,33.0808842 C6.64495968,33.0808842 0,26.3954065 0,18.1484518 C0,9.92734705 6.60336783,3.2579458 14.7648987,3.21621622 Z"
              fill="#FFFFFF"
              stroke="#054C70"
            />
            <path
              d="M18.7236691,3.38715434e-05 C27.8791535,1.14150425 32.8288537,6.17014762 33.5727698,15.085964 L18.8051433,15.0687725 L18.7236691,3.38715434e-05 Z"
              stroke="#05C3DE"
            />
            <path
              d="M14.6766125,18.456563 L4.795086,28.7162162"
              stroke="#054C70"
            />
          </g>
          <g fillRule="nonzero" transform="translate(74.545455, 81.000000)">
            <path
              d="M0,35 C0,15.6700338 15.5750639,0 34.7878788,0 C54.0006937,0 69.5757576,15.6700338 69.5757576,35 L0,35 Z"
              fill="#FFFFFF"
              stroke="#054C70"
            />
            <path
              d="M8.6969697,12.8333333 L11.8661928,15.3841714"
              stroke="#054C70"
              strokeLinecap="square"
            />
            <path
              d="M34.9867861,28.6564659 C35.0550164,28.6524528 35.1237748,28.6504182 35.1930056,28.6504182 C37.1142871,28.6504182 38.6717935,30.2174215 38.6717935,32.1504182 C38.6717935,34.0834148 37.1142871,35.6504182 35.1930056,35.6504182 C33.2717241,35.6504182 31.7142177,34.0834148 31.7142177,32.1504182 C31.7142177,31.2105155 32.0824598,30.3571449 32.6817098,29.728377 L26.6458424,12.25 L34.9867861,28.6564659 Z"
              className="college-branded-icon-needle"
              fill="#05C3DE"
              stroke="#05C3DE"
            />
            <path
              d="M35.0777778,0.875 L35.0777778,4.95833333"
              stroke="#054C70"
              strokeLinecap="square"
            />
            <path
              d="M60.8627658,12.8333333 L57.979798,15.75"
              stroke="#054C70"
              strokeLinecap="square"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

SellDashboard.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default SellDashboard;
